<template>
  <v-app id="inspire">
    <v-app-bar class="cpadding" flat color="primary">
      <v-toolbar-title class="white--text">
        <img src="@/assets/logo.png" style="width: 28px" />
        Dock Loading
        <span style="font-size: 12px">v4</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="white--text mr-4" v-if="isAuthenticated">
        <v-icon class="white--text mr-1 mb-1" small>mdi-account-circle-outline</v-icon>
        <strong class="text-capitalize">{{ firstName }}</strong>
      </div>
      <v-btn @click="doLogout" class="white--text" icon small v-if="isAuthenticated">
        <v-icon small>mdi-logout</v-icon>
      </v-btn>

      <template v-slot:extension v-if="isAuthenticated">
        <v-tabs v-model="tabIndex" centered active-class="active-tab" show-arrows>
          <v-tab @click="navigate('Root')" class="text-capitalize white--text">Docks</v-tab>
          <v-tab @click="navigate('PalletsLogs')" class="text-capitalize white--text">
            Pallet Logs
          </v-tab>
          <v-tab @click="navigate('PalletsStats')" class="text-capitalize white--text">
            Pallet Stats
          </v-tab>
          <template v-if="isAdmin || isSupervisor">
            <v-tab
              @click="navigate('ShippingOfflineLocations')"
              class="text-capitalize white--text"
            >
              Shipping Offline Locations
            </v-tab>
            <v-tab @click="navigate('LoadApprovalPins')" class="text-capitalize white--text">
              Load Approval Pins
            </v-tab>
            <v-tab @click="navigate('LoadApprovalLogs')" class="text-capitalize white--text">
              Load Approval Logs
            </v-tab>
          </template>

          <v-tab @click="navigate('Users')" class="text-capitalize white--text" v-if="isAdmin">
            Users
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-sheet id="mainContainer" class="overflow-y-auto" :max-height="$common.innerHeight">
      <div class="my-5 cpadding" :style="containerStyle">
        <v-layout align-center justify-center wrap>
          <v-flex xs12 sm11 md9>
            <router-view />
          </v-flex>
        </v-layout>
      </div>
    </v-sheet>

    <confirm-popup />
    <status-popup
      type="error"
      color="red"
      :payload="error"
      :top="true"
      :timeout="5000"
      :hasAction="true"
      :mutliline="true"
    />
  </v-app>
</template>

<script>
import store from '@/store';
import { mapState, mapGetters, mapMutations } from 'vuex';

import StatusPopup from '@/components/shared/StatusPopup';

export default {
  name: 'App',
  computed: {
    ...mapGetters('auth', ['firstName', 'isAdmin', 'isSupervisor']),
    ...mapState('error', ['error']),
    tabIndex: {
      get: () => store.state.navigation.tabIndex,
      set: v => store.commit('navigation/setTabIndex', v)
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    containerStyle() {
      const toolbarHeight = 112;
      const totalMargin = 40;
      const { isMobile, innerHeight } = this.$common;
      if (isMobile) return { height: `${innerHeight - totalMargin - toolbarHeight}px` };
      return { height: `${innerHeight - totalMargin - toolbarHeight}px` };
    }
  },
  methods: {
    ...mapMutations('confirm', ['confirm']),
    doLogout() {
      this.confirm({
        message: 'Do you want to logout ?',
        iconColor: 'info',
        acceptAction: () => this.$store.dispatch('auth/logout')
      });
    },
    navigate(name) {
      this.$router.push({ name }).catch(ex => ex);
    }
  },
  components: { StatusPopup }
};
</script>

<style lang="scss">
.cpadding {
  padding: 0 15% !important;
  .v-toolbar__content {
    padding: 0 14% !important;
  }
}

@media (min-width: 340px) and (max-width: 460px) {
  .cpadding {
    padding: 0 12px !important;
    .v-toolbar__content {
      padding: 0 12px !important;
    }
  }
}

@media (min-width: 461px) and (max-width: 1024px) {
  .cpadding {
    padding: 0 24px !important;
    .v-toolbar__content {
      padding: 0 24px !important;
    }
  }
}

.active-tab {
  background: rgba(54, 85, 145, 0.347) !important;
}
</style>
